import { WEBSITE_LOOKUP_STATUS_LABELS, type WebsiteLookupDTO } from '@hearth/shared';

/**
 * The part of a page URL worth showing next to an address ("/contact"), so the user sees at a glance which page
 * published it; the host is already on the row. The site root reads as "the home page".
 */
export function pagePath(url: string): string {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }
  const path = `${parsed.pathname}${parsed.search}`;
  return path === '/' || path === '' ? 'the home page' : path;
}

/** One-line result of reading a website, for a toast: the address and its page, else why there is none. */
export function lookupSummary(lookup: WebsiteLookupDTO): string {
  if (lookup.status === 'found' && lookup.email) {
    return `Found ${lookup.email}${lookup.sourceUrl ? ` on ${pagePath(lookup.sourceUrl)}` : ''}`;
  }
  if (lookup.status === 'pending') return 'The website is queued to be read';
  const label = WEBSITE_LOOKUP_STATUS_LABELS[lookup.status];
  return lookup.message ? `${label} — ${lookup.message}` : label;
}
